import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import cytoscape from 'cytoscape';
import edgehandles from 'cytoscape-edgehandles';
import { Subject, Subscription } from 'rxjs';
cytoscape.use(edgehandles);
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-new-elements',
  templateUrl: './new-elements.component.html',
  styleUrls: ['./new-elements.component.css', '../../mediaquerie.css']
})
export class NewElementsComponent implements OnInit {
  _clicked: Subject<boolean> = new Subject();
  @Input() cy: any;
  @Output() emettoView = new EventEmitter<any>();

  @Input()
  set eventsPageRefresh(val: Subject<boolean>) {
    this._clicked = val;
  }

  private eventsSubscription: Subscription;

  constructor(
    private _formBuilder: FormBuilder,
    iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      'erase_icon',
      sanitizer.bypassSecurityTrustResourceUrl('assets/erase_icon.svg'));
  }
  // variabile edgeHandles
  eh: any;
  // variabile per salvare click del bottone crea nodo
  click = 0;
  // variabile per spostare posizione del nodo/i creati
  position = 0;
  // variabile btn toggle nodi add elementi
  btnToggleaddEntry: boolean = false;
  btnToggleaddSemanticRelation: boolean = false;
  btnToggleLexicalRel: boolean = false;
  btnTogglexxx: boolean = false;

  // variabile per indicare di aggiungere un lexical sense
  addLexicalSense: boolean = false;
  addOtherEntries:boolean = false;
  // variabile btn toggle relazione selezionata check o uncheck
  btnToggleRelationSelected: boolean = false;
  relIpoSelected: boolean = false;
  relIpeSelected: boolean = false;
  relMeroSelected: boolean = false;
  relOloSelected: boolean = false;
  relSinoSelected: boolean = false;
  // variabile btn toggle muovi elemento check o uncheck
  btnToggleMove: boolean = false;
  // variabile btn toggle elimina check o uncheck
  btnToggleDelete: boolean = false;

  // slider label
  disabilitaBtnMenu: boolean = false;
  labelSliderIsCheck: boolean = false;
  // array per salvare nodi creati
  nodiCreati: any = [];

  // dialog visualizza id label definition nodi
  @Output() invioIdNodo = new EventEmitter<any>();
  @Input() labelRicevuta: string;
  @Input() definitionRicevuta: string;


  ngOnInit(): void {
    this.labelSliderIsCheck = true;
    const that = this;
    this.eh = this.cy.edgehandles(
      { snap: false }
    );
    this.cy.on('click', function () {
      that.eh.disableDrawMode();
    });
    // subscription per informare Angular che è avvenuto un cambiamento 
    // il btn reset in header navigazione multipla è stato cliccato tolgo toggle da tutti i btns
    // necessario usare subscription perché onChanges funzionava solo con il primo
    this.eventsSubscription = this._clicked.subscribe((x) => {
      if (x === true) {
        // tolgo stile toggle btns
        this.btnToggleDelete = false;
        this.btnToggleMove = false;
        this.btnToggleaddSemanticRelation = false;
        this.btnToggleaddEntry = false;
        this.btnTogglexxx = false;
        this.btnToggleLexicalRel = false;
        this.click = 0;
        // svuoto array nodi creati
      }
    });

    this.cy.on('dblclick', 'node.createdNode', (evt) => {
      const dialogModifyNode = document.getElementById('dialogModifyNode');
      dialogModifyNode.style.display = 'block';
      this.invioIdNodo.emit(evt.target.data().id);
      sessionStorage.setItem('showDialogModifyNode','true');
    })
    // evento su background chiama metodi in base a btn toggle checkati
    this.cy.on('tap', function (evt) {
      var evtTarget = evt.target;
      if (evtTarget === that.cy && sessionStorage.getItem('navigazioneMultipla') === 'true') {
        // btn toggle crea nodi
        if (that.btnToggleaddEntry === true && that.addLexicalSense=== true) {
          that.addOtherEntries = false;
          that.addNodo(evt);
        }
      }
    });
    // evento su nodo chiama metodi in base a btn toggle checkati
    this.cy.on('tap', 'node.createdNode', function (evt) {
      that.cy.getElementById(evt.target.data().id).ungrabify();
      if (that.relIpoSelected === true || that.relIpeSelected === true ||
        that.relMeroSelected === true || that.relOloSelected === true ||
        that.relSinoSelected === true) {
        that.eh.enableDrawMode();
      }
      if (that.btnToggleDelete === true) {
        this.addLexicalSense = false;
        that.cy.remove(evt.target);
      }
      if (that.btnToggleMove === true) {
        this.addLexicalSense = false;
        that.cy.getElementById(evt.target.data().id).grabify();
        that.eh.disableDrawMode();
      }
    });
    // evento per abilitare il grab solamente quando è cliccato il btn move
    this.cy.on('vmousedown', 'node.createdNode', function (evt) {
      that.cy.getElementById(evt.target.data().id).ungrabify();
      if (that.btnToggleMove === true) {
        that.cy.getElementById(evt.target.data().id).grabify();
      }
    })

    // aggiungo elimina edge al tap su edge di interesse
    this.cy.on('tap', 'edge.crea_iponimi,edge.crea_meronimi,edge.crea_sinonimi', function (evt) {
      if (that.btnToggleDelete === true) {
        that.cy.remove(evt.target);
      }
    });

    // tooltip per nodo creato
    // this.cy.on("mouseover", 'node.createdNode', (event) => {
    //   let node = event.target.data().id;
    //   if (node !== sessionStorage.getItem('currentEle')) {
    //     sessionStorage.setItem('definizioneC', '')
    //   }
    //   sessionStorage.setItem('currentEle', node);
    //   event.target.popperRefObj = event.target.popper({
    //     placement: 'top',
    //     content: () => {
    //       let content = document.createElement('div');
    //       content.classList.add("popper-div");
    //       content.innerHTML = `<p>ID: ` + event.target.data().id + `</p>` + `<p>LABEL: ` + event.target.data().label + `</p>` +
    //         `<p>DEFINITION: ` + sessionStorage.getItem('definizioneC') + `</p>`;
    //       document.body.appendChild(content);
    //       return content;
    //     },
    //     popper: {
    //       placement: 'top-start',
    //       strategy: 'absolute',
    //     }
    //   });
    // });
    // chiudo tooltip
    // this.cy.on('dblclick', 'node.createdNode', (event) => {
    //   // dovrebbe togliere errore undefined
    //   if (event.target.popper) {
    //     event.target.popperRefObj.state.elements.popper.remove();
    //     event.target.popperRefObj.destroy();
    //   }
    // });
  }


  addNodi() {
    this.addLexicalSense = true;
    this.addOtherEntries = false;
  }

  addOtherEntry(){
    this.addOtherEntries = true;
    this.addLexicalSense = false;
  }

  addNodo(evt) {
    const that = this;
    var pos = { x: evt.renderedPosition.x, y: evt.renderedPosition.y };
    var nodo = 'test' + this.click;
    // creo nodo target
    that.cy.add([{
      group: "nodes",
      data: {
        id: nodo,
        label: nodo,
        definition: ''
      },
      renderedPosition: pos,
    }]);
    that.cy.getElementById(nodo).style('display', 'element');
    that.cy.getElementById(nodo).addClass('label');
    that.cy.getElementById(nodo).addClass('createdNode');
    that.click++;
    sessionStorage.setItem('valTarget', nodo);
    this.nodiCreati.push(nodo);
    that.emettoView.emit(nodo);
  }

  btnSelected(evt) {
    const that = this;
    if (evt.source.checked === true) {
      this.btnToggleRelationSelected = true;
      if (evt.value === 'addEntry') {
        this.btnToggleaddEntry = true;
        this.btnTogglexxx = false;
        this.btnToggleaddSemanticRelation = false;
        this.btnToggleLexicalRel = false;
        this.btnToggleMove = false;
        this.btnToggleDelete = false;
      } else if (evt.value === 'addSemanticaRelation') {
        this.btnToggleaddSemanticRelation = true;
        this.btnToggleaddEntry = false;
        this.btnTogglexxx = false;
        this.btnToggleLexicalRel = false;
        this.btnToggleMove = false;
        this.btnToggleDelete = false;
      } else if (evt.value === 'addxxx') {
        this.btnToggleaddEntry = false;
        this.btnTogglexxx = true;
        this.btnToggleaddSemanticRelation = false;
        this.btnToggleLexicalRel = false;
        this.btnToggleMove = false;
        this.btnToggleDelete = false;
      } else if (evt.value === 'addLexicalRel') {
        this.btnToggleLexicalRel = true;
        this.btnToggleaddEntry = false;
        this.btnTogglexxx = false;
        this.btnToggleaddSemanticRelation = false;
        this.btnToggleMove = false;
        this.btnToggleDelete = false;
      } else if (evt.value === 'sposta') {
        this.btnToggleMove = true;
        this.btnToggleLexicalRel = false;
        this.btnToggleaddSemanticRelation = false;
        this.btnToggleaddEntry = false;
        this.btnTogglexxx = false;
        this.btnToggleDelete = false;
        sessionStorage.setItem('btnToggleNodi', 'false')
      } else if (evt.value === 'elimina') {
        this.btnToggleDelete = true;
        this.btnToggleaddSemanticRelation = false;
        this.btnToggleaddEntry = false;
        this.btnTogglexxx = false;
        this.btnToggleMove = false;
        sessionStorage.setItem('btnToggleNodi', 'false')
      } else if (evt.value === 'edit') {
        this.btnToggleaddSemanticRelation = false;
        this.btnToggleaddEntry = false;
        this.btnTogglexxx = false;
        this.btnToggleMove = false;
        this.btnToggleDelete = false;
        sessionStorage.setItem('btnToggleNodi', 'false')
      }
    }
    else {
      this.btnToggleRelationSelected = false;
    }
  }
  // slider label
  isChecked() {
    if (this.labelSliderIsCheck === true) {
      this.cy.edges().style('text-opacity', 1);
      this.cy.edges().filter(':visible').style("edge-text-rotation", "autorotate");
    } else {
      this.cy.edges().style('text-opacity', 0);
    }
  }

  // dialog
  // openDialog(): void {
  //   // resetto dialog prima di aprirlo
  //   this.labelCreata = '';
  //   this.definitionCreata = '';
  //   if (this.dialogRef) {
  //     return;
  //   }
  //   this.dialogRef = this.dialog.open<any>
  //     (DialogModificaNodoComponent, {
  //       disableClose: true,
  //       hasBackdrop: false,
  //       data: {
  //         id: this.idNodoCreato,
  //         label: this.labelCreata,
  //         definition: this.definitionCreata
  //       }
  //     });

  //   if (this.dialogRef.getState() === MatDialogState.OPEN) {
  //     sessionStorage.setItem('dialogIsOpen', 'true')
  //   }
  //   // this.dialogRef.afterClosed().subscribe(result => {
  //   //   this.dialogRef = null;
  //   //   if (result !== undefined) {
  //   //     this.labelCreata = result.label;
  //   //     this.definitionCreata = result.definition;
  //   //     // cambio label nodo cliccato 
  //   //     this.cy.nodes(':selected').style('label', result.label);
  //   //     this.cy.nodes(':selected').style('definition', result.definition);
  //   //     sessionStorage.setItem('definizioneC', result.definition)
  //   //   }

  //   // });

  //   this.dialogRef.afterClosed().subscribe(result => {
  //     console.log(`Dialog result: ${result}`);
  //   });
  // }

  // relazione scelta
  hyponymChosen() {
    this.relIpoSelected = true;
    this.cy.on('ehcomplete', (event, sourceNode, targetNode, addedEdge) => {
      this.cy.batch(function () {
        addedEdge
          .removeClass('crea_sinonimi')
          .removeClass('crea_meronimi')
          .addClass('crea_iponimi')
          .addClass('labelHypo')
          ;
      });
      addedEdge.style('label', 'hyponym');
      addedEdge.style("edge-text-rotation", "autorotate");
      this.click++;
    });
  }

  hypernymChosen() {
    this.relIpeSelected = true;
    this.cy.on('ehcomplete', (event, sourceNode, targetNode, addedEdge) => {
      this.cy.batch(function () {
        addedEdge
          .removeClass('crea_sinonimi')
          .removeClass('crea_meronimi')
          .addClass('crea_iponimi')
          ;
      });
      addedEdge.style('label', 'hypernym');
      addedEdge.style("edge-text-rotation", "autorotate");
    });
  }

  partHolonymChosen() {
    this.relOloSelected = true;
    this.cy.on('ehcomplete', (event, sourceNode, targetNode, addedEdge) => {
      this.cy.batch(function () {
        addedEdge
          .removeClass('crea_sinonimi')
          .removeClass('crea_iponimi')
          .addClass('crea_meronimi')
          ;
      });
      addedEdge.style('label', 'partHolonym');
      addedEdge.style("edge-text-rotation", "autorotate");
    });
  }

  partMeronymChosen() {
    this.relMeroSelected = true;
    this.cy.on('ehcomplete', (event, sourceNode, targetNode, addedEdge) => {
      this.cy.batch(function () {
        addedEdge
          .removeClass('crea_sinonimi')
          .removeClass('crea_iponimi')
          .addClass('crea_meronimi')
          ;
      });
      addedEdge.style('label', 'partMeronym');
      addedEdge.style("edge-text-rotation", "autorotate");
    });
  }

  synonymChosen() {
    this.relSinoSelected = true;
    this.cy.on('ehcomplete', (event, sourceNode, targetNode, addedEdge) => {
      this.cy.batch(function () {
        addedEdge
          .removeClass('crea_meronimi')
          .removeClass('crea_iponimi')
          .addClass('crea_sinonimi')
          ;
      });
      addedEdge.style('label', 'synonym');
      addedEdge.style("edge-text-rotation", "autorotate");
    });
  }
}
